const baseStyle = {};
const defaultProps = {
    size: 'md',
    variant: 'dark'
};
const sizes = {
    xs: {
        item: {
            fontSize: 12,
            lineHeight: '18px'
        },
        separator: {
            size: 'xs'
        }
    },
    sm: {
        item: {
            fontSize: 14,
            lineHeight: '22px'
        },
        separator: {
            size: 'sm'
        }
    },
    md: {
        item: { fontSize: 16, lineHeight: '26px' },
        separator: {
            size: 'md'
        }
    },
    lg: {
        item: { fontSize: 18, lineHeight: '32px' },
        separator: {
            size: 'lg'
        }
    }
};
const variants = {
    dark: {
        item: {
            color: 'seaBlue.main'
        },
        main: {
            bg: 'transparent'
        },
        separator: {
            pathFill: 'sandstone.10'
        }
    },
    white: {
        item: {
            color: 'white'
        },
        main: {
            bg: 'darkBlue.main'
        },
        separator: {
            pathFill: 'white'
        }
    },
    light: {
        item: {
            color: 'digiGreen.main'
        },
        main: {
            bg: 'darkBlue.main'
        },
        separator: {
            pathFill: 'white'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
